class SiteHeaderComponent extends HTMLElement {
  constructor () {
    super()
    this.init()
    this.eventListenersSet = false
  }

  init () {
    this.setSelectors()
  }

  setSelectors () {
    this.selectors = {
      account: '[data-header-account]',
      cart: '[data-header-cart]',
      logo: '[data-header-logo]',
      menu: '[data-header-menu]',
      navigation: '[data-header-navigation]',
      search: '[data-header-search]',
      title: '[data-header-title]',
      wishlist: '[data-header-wishlist]',
      cartCount: '[data-header-cart-count]',
      mobileMenu: '[data-header-mobile-menu]',
      searchMobile: '[data-header-search-mobile]',
    }
  }

  handleMenuToggle (event) {
    event.stopPropagation()
    window.cnvs.EventBus.emit('overlay:toggle', {
      component: 'menu-drawer',
      ignoreDismissed: true,
      namespace: 'menuDrawer',
    })
  }

  handleCartToggle (event) {
    event.stopPropagation()
    window.cnvs.EventBus.emit('overlay:toggle', {
      component: 'cart-drawer',
      ignoreDismissed: true,
      namespace: 'cartDrawer',
    })
  }

  handleWishlistToggle (event) {
    event.stopPropagation()
    window.cnvs.EventBus.emit('overlay:toggle', {
      component: 'wishlist-list',
      ignoreDismissed: true,
      namespace: 'wishlistDrawer',
    })
  }

  handleSearchToggle (event) {
    event.stopPropagation()
    window.cnvs.EventBus.emit('overlay:toggle', {
      component: 'search-drawer',
      ignoreDismissed: true,
      namespace: 'searchDrawer',
    })
  }

  setEventListeners () {
    return new Promise (resolve => {
      if (this.eventListenersSet) {
        return
      }
      this.mobileMenu.removeEventListener('click', this.handleMenuToggle)
      this.mobileMenu.addEventListener('click', this.handleMenuToggle)

      this.elements.cart.removeEventListener('click', this.handleCartToggle)
      this.elements.cart.addEventListener('click', this.handleCartToggle)

      this.elements.wishlist.removeEventListener('click', this.handleWishlistToggle)
      this.elements.wishlist.addEventListener('click', this.handleWishlistToggle)

      this.elements.search.removeEventListener('click', this.handleSearchToggle)
      this.elements.search.addEventListener('click', this.handleSearchToggle)

      this.elements.searchMobile.removeEventListener('click', this.handleSearchToggle)
      this.elements.searchMobile.addEventListener('click', this.handleSearchToggle)

      cnvs.EventBus?.listen('cart:update', () => {
        fetch(cnvs.routes.cart.js)
          .then(response => response.json())
          .then(data => {
            if (data.item_count > 0) {
              this.elements.cartCount.innerHTML = data.item_count
            } else {
              this.elements.cartCount.innerHTML = ''
            }
          })
      })

      resolve()
    })
  }

  connectedCallback () {
    // Wait for DOM to be ready
    requestAnimationFrame(() => {
      // Get DOM elements using selectors
      this.elements = {}
      for (const [key, selector] of Object.entries(this.selectors)) {
        this.elements[key] = document.querySelector(selector)
      }
      this.setEventListeners().then(() => {
        this.eventListenersSet = true
      })
    })
  }

  get mobileMenu () {
    return this.elements.mobileMenu
  }
}

if (!customElements.get('site-header-component')) {
  customElements.define('site-header-component', SiteHeaderComponent)
}
